<template>
  <div class="swipe-content">
    <div class="position-indicator">
      <div class="custom-indicator">
        <div
          :class="[
            'indicator-btn',
            current === 0 ? 'left-btn-disabled' : 'left-btn',
          ]"
          @click="handleChangeSwipeIndexInfor('left')"
        ></div>
        <div class="indicator-con">
          <span
            v-for="(item, index) in groupedTodayAuctionList"
            :key="index"
            :class="[
              index === current ? 'active' : '',
              'custom-indicator-item',
            ]"
          ></span>
        </div>
        <div
          :class="[
            'indicator-btn',
            current === groupedTodayAuctionList.length - 1
              ? 'right-btn-disabled'
              : 'right-btn',
          ]"
          @click="handleChangeSwipeIndexInfor('right')"
        ></div>
      </div>
    </div>
    <van-swipe
      ref="swipeInstance"
      :autoplay="0"
      class="jinri-swipe"
      :style="{ height: currentHeight + 'px' }"
      @change="handleSwipeChangeInfor"
      :show-indicators="false"
    >
      <van-swipe-item
        v-for="(group, groupIndex) in groupedTodayAuctionList"
        :key="groupIndex"
        :style="{ display: 'block' }"
      >
        <div class="swipe-item-wrap" :ref="'content' + groupIndex">
          <div
            class="swipe-item"
            v-for="(item, itemIndex) in group"
            :key="itemIndex"
            @click="
              jumpDetail(
                (item.type == 1 ? '/special/' : '/session/') +
                  item.source_code +
                  waterLink,
                item,
                '6',
                itemIndex
              )
            "
          >
            <div
              :class="[
                'focus-wrap',
                item.bid_type === 1 && item.bid_status == 2
                  ? 'focus-wrap-active'
                  : '',
              ]"
            >
              <div
                :class="[
                  'focus-picture',
                  item.type === 2 && item.bid_type === 1 && item.bid_type === 2
                    ? 'focus-picture-small'
                    : '',
                ]"
              >
                <div v-if="item.cultural_license" class="tag-wrap">
                  <lottie
                    v-if="item.status === 4"
                    class="tag-wenwu"
                    :options="jingpaiOptions"
                    :height="4.72"
                    :width="4.8"
                  />
                  <lottie
                    v-if="item.status === 5"
                    class="tag-wenwu"
                    :options="jieshuOptions"
                    :height="4.72"
                    :width="4.8"
                  />
                  <lottie
                    v-if="item.status === 1"
                    class="tag-wenwu"
                    :options="yuzhanOptions"
                    :height="4.72"
                    :width="4.8"
                  />
                </div>
                <div class="tag-wrap" v-else>
                  <div
                    :class="[
                      'tag-list',
                      item.bid_type === 1 ? 'tag-tongbu' : '',
                      item.bid_type === 2 ? 'tag-xianshi' : '',
                    ]"
                  >
                    <span class="tag-label"></span>
                    <!-- 同步拍 -->
                    <template v-if="item.bid_type === 1">
                      <!-- 进行中 -->
                      <span
                        class="tag-show-Live"
                        v-if="item.bid_status === 2 && item.status_text === ''"
                        ><img src="../../assets/img/list_live.gif"
                      /></span>
                      <!-- <span v-if="item.type == 1 && 
                                                item.bid_status === 2 &&
                                                item.live_status_text != ''"></span> -->
                      <!-- 拍卖中 即将开始 暂停中 -->
                      <span
                        class="tag-show tag-show-paimaizhong"
                        v-if="item.status_text != ''"
                      >
                        {{ item.status_text }}
                      </span>
                    </template>
                    <!-- 限时拍 -->
                    <template v-if="item.bid_type === 2">
                      <span class="tag-show tag-show-paimaizhong">{{
                        item.status_text
                      }}</span>
                    </template>
                  </div>
                </div>
                <div class="cover-picture">
                  <!-- 专场-同步拍-通交易-拍卖中 -->
                  <lottie
                    v-if="
                      item.type == 1 &&
                        item.bid_type === 1 &&
                        item.bid_status === 2
                    "
                    class="breathe-wrap"
                    :options="breatheOptions"
                    :height="8.58"
                    :width="5.71"
                  />
                  <img :src="item.cover_pic" />
                  <!-- 拍卖会-不通交易 -->
                  <template v-if="
                      item.type === 2 &&
                        (item.bid_type != 1 ||
                        item.bid_type != 2)
                    ">
                    <div class="book-shadow-top"></div>
                    <div class="book-shadow-bottom"></div>
                  </template>
                  <p
                    :class="[
                      item.type === 2 &&
                      item.bid_type === 1 &&
                      item.bid_type === 2
                        ? 'show-time-small'
                        : 'show-time',
                    ]"
                  >
                    {{ item.auction_date }}
                  </p>
                </div>
              </div>
              <div class="focus-message">
                <p class="show-name">{{ item.name }}</p>
                <p class="show-address">{{ item.organ_name }}</p>
              </div>
              <div class="focus-option">
                <div
                  :class="[
                    'btnIcon bidBtn',
                    item.bid_type != 1 &&
                    item.bid_type != 2 &&
                    item.show_bid_label === 1
                      ? 'notActivated'
                      : '',
                  ]"
                >
                  <span
                    v-if="item.bid_type === 1 || item.bid_type === 2"
                    class="click-join"
                    ><i class="icon-hammer"></i>点击参拍</span
                  >
                  <span v-else>
                    <template v-if="item.show_bid_label === 1">
                      仅预展
                    </template>
                  </span>
                </div>
                <div
                  class="tag-butie"
                  v-if="item.max_commission_user_ratio != ''"
                >
                  补贴
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="custom-indicator">
      <div
        :class="[
          'indicator-btn',
          current === 0 ? 'left-btn-disabled' : 'left-btn',
        ]"
        @click="handleChangeSwipeIndexInfor('left')"
      ></div>
      <div class="indicator-con">
        <span
          v-for="(item, index) in groupedTodayAuctionList"
          :key="index"
          :class="[index === current ? 'active' : '', 'custom-indicator-item']"
        ></span>
      </div>
      <div
        :class="[
          'indicator-btn',
          current === groupedTodayAuctionList.length - 1
            ? 'right-btn-disabled'
            : 'right-btn',
        ]"
        @click="handleChangeSwipeIndexInfor('right')"
      ></div>
    </div>
  </div>
</template>
<script>
import lottie from "@/components/common/lottie";
import { scMdFunc } from "@/assets/js/scData";
import _ from "lodash";

const breathe_icon = require("../../assets/img/json/breathe_icon.json");
const liveIcon3 = require("../../assets/img/live_icon_3.json");
const jingpai_icon = require("../../assets/img/json/jingpai_jin_icon.json");
const jinrijieshu_icon = require("../../assets/img/json/jinrijieshu_jin_icon.json");
const yuzhan_icon = require("../../assets/img/json/yuzhan_jin_icon.json");

export default {
  data() {
    return {
      current: 0,
      breatheOptions: {
        animationData: breathe_icon,
        loop: true,
        autoplay: true,
      },
      heartOptions3: {
        animationData: liveIcon3,
        loop: true,
        autoplay: true,
      },
      jingpaiOptions: {
        animationData: jingpai_icon,
        loop: true,
        autoplay: true,
      },
      jieshuOptions: {
        animationData: jinrijieshu_icon,
        loop: true,
        autoplay: true,
      },
      yuzhanOptions: {
        animationData: yuzhan_icon,
        loop: true,
        autoplay: true,
      },
      waterLink: "",
      currentHeight: 0,
    };
  },
  mounted() {
    if (
      (this.$route.query.from && this.$route.query.from == 1) ||
      this.$route.query.from == 1
    ) {
      this.waterLink = "?from=" + this.$route.query.from;
    }
    this.calculateHeights();
    // 监听窗口变化
    // window.addEventListener("resize", this.handleResize);
  },
  methods: {
    jumpDetail(e, item, i, index) {
      if (item.type == 1) {
        scMdFunc("allClick", {
          cur_page: "1",
          cur_moudle: "1-" + i,
          cur_button: "1-" + i + "-" + Number(index + 1),
          auction_specia_performance_id_pk: item.special_id,
          auction_specia_performance_id: item.special_code,
          the_auction_id_pk: item.session_id,
          the_auction_id: item.session_code,
          auction_company_id: item.organ_id,
          auction_company_code: item.organ_code,
          auction_state:
            item.status == 1
              ? "待拍卖"
              : item.status == 2
              ? "预展中"
              : item.status == 3
              ? "待预展"
              : item.status == 4
              ? "拍卖中"
              : item.status == 5
              ? "已结拍"
              : "",
          auction_type: item.bid_type,
        });
      } else {
        scMdFunc("allClick", {
          cur_page: "1",
          cur_moudle: "1-" + i,
          cur_button: "1-" + i + "-" + Number(index + 1),
          the_auction_id_pk: item.session_id,
          the_auction_id: item.session_code,
          auction_company_id: item.organ_id,
          auction_company_code: item.organ_code,
          auction_state:
            item.status == 1
              ? "待拍卖"
              : item.status == 2
              ? "预展中"
              : item.status == 3
              ? "待预展"
              : item.status == 4
              ? "拍卖中"
              : item.status == 5
              ? "已结拍"
              : "",
          auction_type: item.bid_type,
        });
      }

      this.$router.push({
        path: e,
        query: {
          scId: "",
          scFrom:
            "1-" +
            i +
            "-" +
            Number(index + 1) +
            "-" +
            (item.type == 1 ? item.special_code : "0") +
            "-0",
        },
      });
    },
    handleSwipeChangeInfor(index) {
      this.current = index;
      this.currentHeight = this.heights[index] || this.currentHeight;
    },
    calculateHeights() {
      this.$nextTick(() => {
        this.heights = this.groupedTodayAuctionList.map((_, index) => {
          const el = this.$refs["content" + index][0];
          return el ? el.scrollHeight + 10 : 0;
        });
        this.currentHeight = Math.max(...this.heights, 200) + 10;
      });
    },
    // handleResize: _.debounce(function() {
    //   // 使用防抖函数优化性能
    //   this.calculateHeights();
    // }, 300),
    handleChangeSwipeIndexInfor(type) {
      if (type === "left") {
        if (this.current > 0) {
          this.current--;
          this.$refs.swipeInstance.prev(); // 切换到上一页
        }
      } else {
        if (this.current < this.groupedTodayAuctionList.length - 1) {
          this.current++;
          this.$refs.swipeInstance.next(); // 切换到下一页
        }
      }
    },
  },
  computed: {
    groupedTodayAuctionList() {
      if (!this.todayAuctionList || !Array.isArray(this.todayAuctionList)) {
        return [];
      }
      const chunkSize = 9;
      const result = [];
      for (let i = 0; i < this.todayAuctionList.length; i += chunkSize) {
        result.push(this.todayAuctionList.slice(i, i + chunkSize));
      }
      return result;
    },
  },
  props: {
    todayAuctionList: {
      type: Array,
      default: [],
    },
  },
  components: {
    lottie,
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
.swipe-content {
  padding: 0 0.75rem;
  position: relative;
  .jinri-swipe {
    .swipe-item-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      height: 100%;
      .swipe-item {
        width: calc((100% - 0.09rem) / 3);
        margin: 0 0.04rem 0.4rem 0;
        position: relative;
        box-sizing: border-box;
        overflow: visible !important;
        z-index: 1;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .focus-wrap {
          width: 100%;
          box-sizing: border-box;
          padding: 0.15rem 0.13rem;
          .focus-picture {
            position: relative;
            border-radius: 0.44rem;
            overflow: visible !important;
            z-index: 2;
            .cover-picture {
              position: relative;
              overflow: visible !important;
              z-index: 3;
              .breathe-wrap {
                position: absolute;
                top: -0.62rem;
                left: -0.16rem;
                width: 5.6rem;
                height: 7.2rem;
                z-index: 10;
              }
              img {
                width: 5.4rem;
                height: 7.2rem;
                object-fit: cover;
                border-radius: 0.34rem;
              }
              .book-shadow-top {
                width: 80%;
                height: 6.74rem;
                position: absolute;
                top: 0.8rem;
                left: 50%;
                margin-left: -40%;
                background-color: rgba(136, 136, 136, 0.4);
                border-radius: 0.44rem;
                z-index: -2;
              }
              .book-shadow-bottom {
                width: 90%;
                height: 6.4rem;
                position: absolute;
                top: .98rem;
                left: 50%;
                margin-left: -45%;
                background-color: rgba(170, 170, 170, 0.6);
                border-radius: 0.44rem;
                z-index: -3;
              }
            }
          }
          .focus-picture-small {
            width: 4.96rem;
            .cover-picture {
              img {
                width: 5.78rem;
                height: 7.2rem;
              }
            }
          }
          .tag-wrap {
            position: relative;
            z-index: 4;
            .tag-list {
              position: relative;
              .tag-label {
                width: 1.9rem;
                height: 0.8rem;
                display: inline-block;
                position: absolute;
                top: 0.25rem;
                left: 0.25rem;
                background-size: 100%;
                background-repeat: no-repeat;
                z-index: 2;
              }
              span {
                display: block;
                text-align: center;
              }
              .tag-show {
                position: absolute;
                top: 0.25rem;
                left: 2rem;
                height: 0.8rem;
                border-top-right-radius: 0.21rem;
                border-bottom-right-radius: 0.21rem;
                font-size: 0.46rem;
                font-weight: normal;
                white-space: nowrap;
                color: #000;
                background-color: #fff;
                padding: 0.06rem 0.17rem 0 0.2rem;
                z-index: 1;
              }
              .tag-show-Live {
                position: absolute;
                top: 0.25rem;
                right: 0.37rem;
                background-color: #f22c2c;
                border-radius: 0.24rem;
                width: 1rem;
                height: 1rem;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  height: 0.43rem;
                  width: 0.43rem;
                  border-radius: 0;
                  display: block;
                }
              }
            }
            .tag-tongbu {
              span.tag-label {
                background-image: url(../../assets/img/icon_tongbupai@2x.png);
              }
              .tag-show-paimaizhong {
                border: 0.03rem solid #ff627a;
              }
            }
            .tag-xianshi {
              span.tag-label {
                background-image: url(../../assets/img/icon_xianshipai@2x.png);
              }
              .tag-show-paimaizhong {
                background-color: #fff;
                position: absolute;
                top: 0.25rem;
                left: 2rem;
                height: 0.8rem;
                border: 0.03rem solid #e4e9f5;
                border-top-right-radius: 0.21rem;
                border-bottom-right-radius: 0.21rem;
                font-size: 0.42rem;
                font-weight: normal;
                white-space: nowrap;
                color: #000;
                padding: 0.06rem 0.17rem 0 0.2rem;
                z-index: 1;
              }
            }
            .tag-wenwu {
              position: absolute;
              top: -1.72rem;
              left: 0rem;
            }
          }
        }
        .focus-message {
          margin: 0.3rem 0 0.22rem;
          p.show-name {
            font-size: 0.7rem;
            color: #000000;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
          }
          p.show-name::after {
            content: "";
            position: absolute;
            right: 0;
            top: 0;
            width: 40px;
            height: 100%;
            background-image: url(../../assets/img/icon_semi_transparent@2x.png);
            background-repeat: no-repeat;
            background-size: 100%;
          }
          .show-address {
            font-size: 0.65rem;
            color: #6b6c6c;
          }
        }
        .focus-option {
          display: inline-block;
          position: relative;
          .tag-butie {
            position: absolute;
            right: -0.9rem;
            top: -0.3rem;
            background-color: #fff1f2;
            border-radius: 0.48rem;
            font-size: 0.5rem;
            color: #ff0000;
            display: inline-block;
            padding: 0.05rem 0.33rem 0;
          }
          .btnIcon {
            height: 1.2rem;
            line-height: 1.2rem;
            padding: 0 0.4rem 0 0.4rem;
            font-size: 0.5rem;
            border-radius: 1rem;
            color: #ffffff;
            .svg {
              display: inline-block;
              vertical-align: middle;
            }
            .click-join {
              display: flex;
              align-items: center;
              i.icon-hammer {
                width: 0.65rem;
                height: 0.65rem;
                display: inline-block;
                background-image: url(../../assets/img/icon_hammer@2x.png);
                background-size: 0.65rem 0.65rem;
                background-repeat: no-repeat;
                margin-right: 0.1rem;
              }
            }
          }
          .canpaiBtnIcon {
            background: #f6344b;
          }
          .bidBtn {
            background: #009b5f;
          }
          .notActivated {
            background-color: #f5f5f5;
            color: #949596;
            padding: 0 0.5rem;
          }
        }
        .show-time-small {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 4.95rem;
          height: 1.89rem;
          line-height: 1.9rem;
          font-size: 0.67rem;
          padding: 0 0.33rem;
          color: #fff;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6)
          );
          border-radius: 0rem 0rem 0.44rem 0.44rem;
        }
        .show-time {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 99%;
          height: 1.89rem;
          line-height: 2.2rem;
          font-size: 0.6rem;
          padding: 0 0.3rem;
          color: #fff;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6)
          );
          border-radius: 0rem 0rem 0.44rem 0.44rem;
        }
      }
    }
    /deep/.van-swipe {
      height: 8.05rem;
      width: 100%;
      border-radius: 0.5rem;
      overflow: hidden;
    }
  }
}
.custom-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  .indicator-btn {
    width: 0.7rem;
    height: 0.7rem;
    background-size: 0.7rem 0.7rem;
    background-repeat: no-repeat;
  }
  .left-btn {
    background-image: url("../../assets/img/swipper_button@2x.png");
  }
  .left-btn-disabled {
    background-image: url("../../assets/img/swipper_button_disabled@2x.png");
    transform: rotate(180deg);
  }
  .right-btn {
    background-image: url("../../assets/img/swipper_button@2x.png");
    transform: rotate(180deg);
  }
  .right-btn-disabled {
    background-image: url("../../assets/img/swipper_button_disabled@2x.png");
  }
  .indicator-con {
    display: flex;
    align-items: center;
    margin: 0 0.4rem;
    span {
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      background-color: rgba(0, 0, 0, 0.2);
      margin-right: 0.25rem;
      border-radius: 50%;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background-color: rgba(0, 155, 95, 1);
      }
    }
  }
}
.position-indicator {
  position: absolute;
  right: 0.9rem;
  top: -1.3rem;
}
</style>
